// Derivation input paths (spec 2026-10-06-13): `code`, `parent.<type>.<code>`,
// `children.<type>.<code>` (spec 2026-10-06-17), `today`. Mirrors internal/handlers/derivations/inputs.go.

export const INPUT_TODAY = 'today'

const PARENT_PREFIX = 'parent.'
const CHILDREN_PREFIX = 'children.'

export function parentInputPath(typeCode: string, code: string): string {
  return `${PARENT_PREFIX}${typeCode}.${code}`
}

export function childrenInputPath(typeCode: string, code: string): string {
  return `${CHILDREN_PREFIX}${typeCode}.${code}`
}

export interface ParsedInput {
  kind: 'own' | 'parent' | 'children' | 'today'
  code?: string
  typeCode?: string
}

export function parseInput(path: string): ParsedInput {
  if (path === INPUT_TODAY) return { kind: 'today' }
  if (path.startsWith(PARENT_PREFIX)) {
    const rest = path.slice(PARENT_PREFIX.length)
    const dot = rest.indexOf('.')
    if (dot > 0) return { kind: 'parent', typeCode: rest.slice(0, dot), code: rest.slice(dot + 1) }
  }
  if (path.startsWith(CHILDREN_PREFIX)) {
    const rest = path.slice(CHILDREN_PREFIX.length)
    const dot = rest.indexOf('.')
    if (dot > 0) return { kind: 'children', typeCode: rest.slice(0, dot), code: rest.slice(dot + 1) }
  }
  return { kind: 'own', code: path }
}

// The property code an input reads, on the asset, an ancestor or the descendants.
export function inputPropertyCode(path: string): string | undefined {
  return parseInput(path).code
}

export function sortInputs(paths: string[]): string[] {
  return Array.from(new Set(paths)).sort()
}
